module.exports = __webpack_public_path__ + "static/media/ico-dashboard.c65fbd7b.svg";